Last Modified: 2024/03/21 16:55:38
<template>

    <div class="widget-item">
        <div class="widget-item-body">

            <div class="widget-item-text">

                <p class="widget-item-description" v-if="widget.description">{{ widget.description }}</p>

                <p class="mb-3">
                    The risk of <b>{{ widget.title }}</b> is <span v-if="output">{{ output.toFixed(1) }}%
                        ({{ riskLevel }})</span>
                </p>

                <!-- <p>
                    At this level of risk there is
                </p> -->

                <ul class="p-3">
                    <li v-for="(info, index) in widget.parameters.riskInformation" :key="index">
                        {{ riskValues[index][strataIndex] }}% {{ info }}</li>
                </ul>

            </div>

            <div class="widget-item-chart">

                <canvas :id="`chart_${widget.id}`" />

            </div>

            <div class="chart-key">

                <div class="key" v-for="(name, index) in strataNames" :key="`key_${name}`">
                    <div class="key-color" :style="`background-color: ${widget.parameters.strataColor[index]}`">
                    </div>
                    <div class="key-name">{{ name }}</div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { parseData, initChart } from '@/components/charts/RiskStratification.js'

export default {
    name: 'RiskStratificationWidget',
    props: {
        widget: Object
    },
    data() {
        return {
            keyActive: false,
            chart: null
        }
    },
    computed: {
        variables() {
            return this.widget.variables
        },
        variableIds() {
            return this.variables.map(variable => variable.id)
        },
        labels() {
            return this.variables.map(variable => variable.name)
        },
        states() {
            return this.widget.alt_states ? this.widget.alt_states : this.variables[0].states
        },
        outputData() {
            return this.$store.getters['getOutputs'](this.variables)
        },
        output() {
            return this.outputData[0] ? parseData(this.outputData, this.widget.parameters.target_states)[0] : null
        },
        cumulativeStrata() {
            let tot = 0
            return this.widget.parameters.strata.map((el) => {
                tot = tot + el
                return tot
            })
        },
        strataIndex() {
            return this.cumulativeStrata.findIndex((value) => value > this.output)
        },
        riskValues() {
            return this.widget.parameters.riskValues
        },
        strataNames() {
            return this.widget.parameters.strataNames
        },
        riskLevel() {
            return this.strataNames[this.strataIndex]
        }
    },
    watch: {
        outputData(data) {

            data = parseData(data, this.widget.parameters.target_states)

            for (let i = 0; i < data.length; i++) {
                this.chart.data.datasets[i].data = [data[i]]
            }

            this.chart.update()
        }
    },
    mounted() {
        const ctx = document.getElementById(`chart_${this.widget.id}`)
        this.chart = initChart(ctx, this.labels, this.states, this.outputData, this.widget.parameters)
    }
}


</script>

<style scoped>
.chart-key {
    margin-top: 10px;
}

.key {
    display: flex;
    margin-bottom: 5px;
    align-items: center;
}

.key-color {
    width: 20px;
    height: 20px;
    border-radius: 3px;
    margin-right: 5px;
}

.key-active {
    display: none;
}
</style>